import { createFileRoute, notFound, redirect } from '@tanstack/react-router'
import { isAxiosError } from 'axios'
import * as v from 'valibot'

import keycloak from '@/core/keycloak'
import { tryCatch } from '@/core/utils/tryCatch'
import { company } from '@/http/api/company'

const validateSearch = v.object({
  login_hint: v.optional(v.string()),
  redirect_uri: v.optional(v.string()),
  locale: v.optional(v.string()),
})

export const Route = createFileRoute('/login/$ssoSourceId')({
  validateSearch,
  beforeLoad: async ({ params: { ssoSourceId }, search, buildLocation }) => {
    const [error] = await tryCatch(
      company.noEmailUsers.details({ params: { ssoSourceId } }),
    )

    if (error) {
      if (isAxiosError(error) && error.response?.status === 404) {
        throw notFound()
      }
      throw error
    }

    const homeLocation = `${window.location.origin}${buildLocation({ to: '/home' }).href}`
    const url = new URL(
      keycloak.createLoginUrl({
        loginHint: search.login_hint,
        redirectUri: search.redirect_uri || homeLocation,
        locale: search.locale,
      }),
    )
    url.searchParams.set('sso_source_id', ssoSourceId)

    throw redirect({ href: url.toString() })
  },
})
